import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/pro-light-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight';
import { faPlus } from '@fortawesome/pro-light-svg-icons/faPlus';
import { TypedMemo } from '../../common/types';
import { SMLButton } from '../../music24/components/primitives/SMLButton';
import { tourMessages as messages } from './tourMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the guide bar; each part uses its own slice of it */
import styles from './TourGuideBar.module.scss';
/* eslint-enable css-modules/no-unused-class */

export interface TourGuideActionsProps {
  isFirst: boolean;
  isLast: boolean;
  isMember: boolean;
  onBack: () => void;
  onNext: () => void;
  onExit: () => void;
}

/** Exit tour, Back and Next. The last stop shows "Add my song", or "Open the workspace" for a member (b6). */
const TourGuideActionsComponent: React.FC<TourGuideActionsProps> = ({
  isFirst,
  isLast,
  isMember,
  onBack,
  onNext,
  onExit,
}) => {
  const intl = useIntl();
  let primary: React.ReactNode;
  if (!isLast) {
    primary = (
      <SMLButton variant="primary" className={styles.button} onClick={onNext}>
        {intl.formatMessage(messages.next)}
        <FontAwesomeIcon icon={faChevronRight} aria-hidden="true" />
      </SMLButton>
    );
  } else if (isMember) {
    primary = (
      <SMLButton variant="primary" className={styles.button} onClick={onNext}>
        {intl.formatMessage(messages.memberOpen)}
      </SMLButton>
    );
  } else {
    primary = (
      <SMLButton
        variant="primary"
        className={styles.button}
        icon={<FontAwesomeIcon icon={faPlus} aria-hidden="true" />}
        onClick={onNext}
      >
        {intl.formatMessage(messages.addSong)}
      </SMLButton>
    );
  }

  return (
    <div className={styles.actions}>
      <button type="button" className={styles.exit} onClick={onExit}>
        {intl.formatMessage(messages.exit)}
      </button>
      <SMLButton
        className={styles.button}
        disabled={isFirst}
        icon={<FontAwesomeIcon icon={faChevronLeft} aria-hidden="true" />}
        onClick={onBack}
      >
        {intl.formatMessage(messages.back)}
      </SMLButton>
      {primary}
    </div>
  );
};

export const TourGuideActions = TypedMemo(TourGuideActionsComponent);
